import api from "@/services/api.service";

export default {
  name: 'response-contact',
  components: {},
  props: {
    caption: {
      type: String,
      default: "Duplicate Mass Imported Contact List"
    },
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      items: [],
      items_new: [],
      fields: [
      { key: "#" },
      { key: "actions" },
      { key: "status", sortable:true }],
      sech: {},
      currentPage: 1,
      currentPage1: 1,
      perPage: 1,
      perPage1: 1,
      totalRows: null,
      totalRows1: null,
      totalResponseContact: null,
      totalResponseContact1: null,
      isBusy: true,
      delete_ids: [],
      allSelected: false,
      allSelectedNew: false,
      conflict_cnt:'' ,
      permission_importedList: false,
      permission_viewConflict: false,
      permission_deleteImportedContact: false,  
      superAdmin:false    
    };
  },
  computed: {},
  mounted () {},
  async created() {
    let response = await api.post("users/user-permissions");
        const permissions = [];
        if (response.status == "success") {
          response.data[0].permission.forEach( function(element) {                
              permissions.push(element.action)
          }.bind(this));
            if(permissions.includes("list_duplicate_mass_imported_contact") == true){
              this.getDuplicateImportedContacts();
              this.getDuplicateImportedContactsNew();
              this.permission_importedList = permissions.includes("list_duplicate_mass_imported_contact");
              this.permission_viewConflict = permissions.includes("view_duplicate_mass_conflict_imported_contact");
              this.permission_deleteImportedContact = permissions.includes("delete_duplicate_mass_imported_contact");
            }else if(response.data[0].role == 'super_admin'){
              this.getDuplicateImportedContacts();
              this.getDuplicateImportedContactsNew();
              this.superAdmin = true;
          }else if(permissions.includes("list_duplicate_mass_import_contact") == true || permissions.includes("add_duplicate_mass_import_contact") == true){
                this.makeToast("Permission denied","Alert","warning",6000);
                this.$router.push({name: 'Duplicate Mass Import List'});
            }else{
                this.makeToast("Permission denied","Alert","warning",6000);
                this.$router.push({name: 'Admin Dashboard'});
            }
        } 
  },
  watch: {
    currentPage: {
      handler: function(page) {         
          this.getDuplicateImportedContacts(page)
      }
    },
    currentPage1: {
      handler: function(page) {         
          this.getDuplicateImportedContactsNew(page)
      }
    }

  },
  methods: {
    makeToast(message = "", title = "Alert", variant = "warning") {
      this.toastCount++;
      this.$root.$bvToast.toast(message, {
        title: title,
        variant: variant,
        autoHideDelay: 3000
      });
    },
    selectAll: function(e) {
      this.delete_ids = [];            
      if(e.target.checked){
        for (var item in this.items) {
          this.delete_ids.push(this.items[item].id.toString());
        }                
      }            
    },
    selectAllNew: function(e) {
      this.delete_ids = [];            
      if(e.target.checked){
        for (var item in this.items_new) {
          this.delete_ids.push(this.items_new[item].id.toString());
        }                
      }            
    },
    selectOne(){
      this.allSelected = false;            
    },
    selectOneNew(){
      this.allSelectedNew = false;            
    },
    async getDuplicateImportedContacts(page) {
      this.items = [];
        
      this.sech.page = page;
      this.sech.import_contact_id = this.$route.params.id;
      let response = await api.post("admin/duplicate-mass-import/duplicate-imported-contact-list", this.sech);   
      // console.log(response);       
      if (!response)
        this.makeToast("Something went to wrong please try again","Alert","danger",6000);
      if (response.status == "success") {
        if (response.data.records.data != "") {  
          //GET ALL HEADERS FROM JSON        
          var columns = Object.keys(Object.assign({}, ...[JSON.parse(response.data.records.data[0].contact_data)]));

          columns.splice(0,0);
          columns.map((h) => {
           this.fields.push({key: h, sortable: true}) 
         });

          //Iterate Data 
          response.data.records.data.forEach( function(element) {       
            if(element.status == 'Resolved' || element.status == 'Pending'){                             
              var someObject = Object.assign({}, JSON.parse(element.contact_data), {id:element.id,status:element.status} )
              this.items.push(someObject);  
            }  
          }.bind(this));
              this.conflict_cnt = response.data.conflict_cnt;               
              this.totalResponseContact = response.data.records.total;        
              this.currentPage = response.data.records.current_page;
              this.perPage = response.data.records.per_page;
        } else {
          this.items = [];
        }
      }      
      this.isBusy = false;
    }, 
     async getDuplicateImportedContactsNew(page) {
      this.items_new = [];

      this.sech.page = page;
      this.sech.import_contact_id = this.$route.params.id;
      let response = await api.post("admin/duplicate-mass-import/duplicate-imported-contact-list-new", this.sech);   
      if (!response)
        this.makeToast("Something went to wrong please try again","Alert","danger",6000);
      if (response.status == "success") {
        if (response.data.records.data != "") {  
          //GET ALL HEADERS FROM JSON        
          var columns = Object.keys(Object.assign({}, ...[JSON.parse(response.data.records.data[0].contact_data)]));

          columns.splice(0,0);
          columns.map((h) => {
           this.fields.push({key: h, sortable: true}) 
         });

          //Iterate Data 
          response.data.records.data.forEach( function(element1) {       
            if(element1.status == 'New'){                             
              var someObject1 = Object.assign({}, JSON.parse(element1.contact_data), {id:element1.id,status:element1.status.charAt(0).toUpperCase() + element1.status.slice(1)} )
              this.items_new.push(someObject1);                
            }  
          }.bind(this));
              this.totalResponseContact1 = response.data.records.total;        
              this.currentPage1 = response.data.records.current_page;
              this.perPage1 = response.data.records.per_page;
        } else {
          this.items_new = [];
        }
      }      
      this.isBusy = false;
    },
    getRowCount(items) {    
      return items.length;
    },
  multipleDelete(){
    this.$bvModal
    .msgBoxConfirm("Are you sure want to delete this contacts?")
    .then(value => {
      if (value) {
        this.deleteDuplicateImportedContact(this.delete_ids, 0);
      } else {
        return;
      }
    })
    .catch(function() {
      return;
    });
  },singleDelete(id, index) {
    this.$bvModal
    .msgBoxConfirm("Are you sure want to delete this contact?")
    .then(value => {
      if (value) {
        this.deleteDuplicateImportedContact(id, index);
      } else {
        return;
      }
    })
    .catch(function() {
      return;
    });
  },
  async deleteDuplicateImportedContact(id, index) {

    let response = await api.post("admin/duplicate-mass-import/delete-duplicate-imported-contact",
      { id: id , import_contact_id : this.$route.params.id });

    if (!response)
      this.makeToast("Something went to wrong please try again","Alert","danger",6000);

    if (response.status == "success") {

      if(index == 0){
        this.items = [];
        this.getDuplicateImportedContacts();
      }
      else
        this.items.splice(index, 1);

      this.makeToast(response.message || `Contact delete successful.`,"Alert","success");
    } 
    else 
      this.makeToast(`Contact not deleted.`, "Alert", "danger");
  },
  async showConflict(id){    
    return this.$router.push({name : "Duplicate Imported Contact Conflict",params: {conflict_id:id}});
  }

  }
}


